"use client";
import { useAppConfiguration } from "appConfig";
import Script from "next/script";
import { useCookieYesConsent } from "utils";

export function RootLayoutHead() {
  const { isMemoringApp, isJinnyApp } = useAppConfiguration();
  const clarityScript = useCookieYesConsent();

  return (
    <>
      {isMemoringApp ? (
        <Script
          id="cookieScript"
          strategy="beforeInteractive"
          src="//cdn.cookie-script.com/s/b22aca7a131ff2e8ccffa637d8f056b3.js"
        />
      ) : null}
      {isJinnyApp ? (
        <Script
          id="cookieyes"
          strategy="lazyOnload"
          src="https://cdn-cookieyes.com/client_data/8c0034686847f9065b139136/script.js"
        />
      ) : null}
      {clarityScript}
      {isMemoringApp ? (
        <>
          <Script id="fb-pixel" strategy="lazyOnload">
            {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '397539699560510');
fbq('track', 'PageView');
`}
          </Script>
          <noscript>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              height="1"
              width="1"
              alt="Facebook Pixel"
              style={{
                display: "none",
              }}
              src="https://www.facebook.com/tr?id=397539699560510&ev=PageView&noscript=1"
            />
          </noscript>
        </>
      ) : (
        <>
          <Script id="meta-pixel-eventJinny" strategy="afterInteractive">
            {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '322198433817949');
          fbq('track', 'PageView');`}
          </Script>
        </>
      )}
    </>
  );
}
